import { render, staticRenderFns } from "./FeatureEditor.vue?vue&type=template&id=95f84d3c&"
import script from "./FeatureEditor.vue?vue&type=script&lang=ts&"
export * from "./FeatureEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports